import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips/';

export const FaqTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace('components/faq');
